import React, { useEffect, useState } from "react";

import { Card, Divider, Icon } from "@mui/material";

import VuiBox from "@/Components/VuiBox";
import VuiTypography from "@/Components/VuiTypography";

import VuiButton from "@/Components/VuiButton";
import VuiInput from "@/Components/VuiInput";

import { Company } from "@/DatabaseControls/DataTypes";
import { firebaseSingleton } from "@/DatabaseControls/FirebaseController";

import CompanyCard from "./CompanyCard";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function applySearch(searchTerm: string, listData: Company[]) {
  return listData.filter((company: Company) => {
    return (
      company.Name?.includes(searchTerm) ||
      company.Name?.includes(searchTerm) ||
      company.id?.toString().includes(searchTerm)
    );
  });
}

function CompanyList({
  listData,
  refreshData,
}: {
  listData: Company[];
  refreshData: () => void;
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchPlaceholder, setSearchPlaceholder] = useState("");
  const handleSetSearchTerm = (e) => setSearchTerm(e.target.value);
  const navigateToCompanyWindow = () => {
    navigate(`/companies/new`, {});
  };

  const deleteCompany = (id: string) =>
    firebaseSingleton.deleteCompany(id).then(refreshData);

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    setSearchPlaceholder(t("common.messages.search"));
  }, [t]);

  return (
    <Card>
      <VuiBox display="flex" justifyContent="space-between" alignItems="center">
        <VuiTypography variant="lg" fontWeight="bold" color="white">
          {t("modules.companies.section_titles.list")}
        </VuiTypography>
        <VuiBox display="flex" justifyContent="space-between">
          <VuiBox pr={2} maxWidth={{ sm: "175px", md: "100%" }}>
            <VuiInput
              placeholder={searchPlaceholder}
              onChange={handleSetSearchTerm}
              icon={{ component: "search", direction: "left" }}
              sx={({ breakpoints }) => ({
                [breakpoints.down("sm")]: {
                  maxWidth: "80px",
                },
                [breakpoints.only("sm")]: {
                  maxWidth: "80px",
                },
                backgroundColor: "info.main !important",
              })}
            />
          </VuiBox>
          <VuiButton
            onClick={navigateToCompanyWindow}
            variant="contained"
            color="info"
            sx={{ minWidth: "48px", minHeight: "36px", padding: 0 }}
          >
            <Icon>add</Icon>
          </VuiButton>
        </VuiBox>
      </VuiBox>
      <Divider />
      <VuiBox>
        <VuiBox
          component="ul"
          display="flex"
          flexDirection="column"
          p={0}
          m={0}
        >
          {applySearch(searchTerm, listData).map(
            (company: Company, i: number) => {
              return (
                <CompanyCard
                  color="success"
                  onClick={() =>
                    navigate(`/companies/${company.id}`, {
                      state: {
                        company,
                      },
                    })
                  }
                  deleteCompany={deleteCompany}
                  key={company.id}
                  title={company.Name}
                  email={company.Email}
                  company={company.id + ""}
                  address={company.Address}
                  noDivider={i === listData.length - 1}
                />
              );
            },
          )}
        </VuiBox>
      </VuiBox>
    </Card>
  );
}

export default CompanyList;
